import React from 'react';
import { connect } from 'react-redux';
import { loginUser, logoutUser } from '../../actions';
import { TextInput } from '../../actions';
import { sendRequest, postData } from '../../utils/request.js';
import Button from "../form/Button";
import Icon from "../form/Icon";

class LockScreen extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            pw: '',
            disabled: false
        };
        this.onUnload = this.onUnload.bind(this);
    }

    onUnload(event) { // the method that will be used for both add and remove event
        this.props.logoutUser();
    }

    unlock = () => {
        this.props.loginUser(() => {
            this.props.onUnlock();
            this.setState({disabled: false});
        });
    }

    login = async () => {
        this.setState({disabled: true});
        if(this.state.pw !== ''){
            const response = await postData({ action: "currentuser.loginuser", "email": this.props.user.email, "password": this.state.pw});
            this.setState({disabled: false});
            if(response.success){
                this.unlock();
            }else{
                this.setState({error: (response.msg ? response.msg : "Bejelentkezés sikertelen!")});
                this.setState({disabled: false});
            }
        }
    }

    componentDidMount() {
        window.addEventListener("beforeunload", this.onUnload)
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onUnload)
    }

    render() {
        const largelogo = window.envBooqadmin.largelogo ? <span dangerouslySetInnerHTML={{__html: window.envBooqadmin.largelogo}}/> : <span><b>booq</b>admin</span>;
        const disabled = this.state.disabled;
        let error = null;
        if(this.state.error) {
            error = <div className="lockscreen-error"><div className="alert alert-danger">{this.state.error}</div></div>;
        }
        return <div className="lockscreen-wrapper">
                <div className="lockscreen-logo">
                    <a href="#">{largelogo}</a>
                </div>
                <div className="lockscreen-name">{this.props.user.name}</div>

                <div className="help-block text-center">
                    Kérlek írd be a jelszavad a folytatáshoz!
                </div>

                <div className="lockscreen-item">

                    <form className="lockscreen-credentials" onSubmit={(e) => {this.login(); e.preventDefault();}}>
                        <div className="input-group">
                            <input autoFocus="on" type="password" disabled={disabled} className="form-control" onChange={(e)=> this.setState({ pw: e.target.value })} placeholder="jelszó"/>

                                <div className="input-group-btn">
                                    <Button disabled={disabled} type="submit" className="btn" icon={{lib: "fa", name: "arrow-right", className: "text-muted"}} />
                                </div>
                        </div>
                    </form>

                </div>

                {error}

                <div className="text-center">
                    <a href="#" onClick={() => {this.props.logoutUser(); this.unlock();}}>Vagy jelentkezz be másként</a>
                </div>
            </div>;
    }
}

export default connect(
    (state) => {
        return {

        };
    },
    {
        loginUser, logoutUser
    }
)(LockScreen);